import { FormControl, TextField } from '@mui/material';
import { ChangeEventHandler } from 'react';

type Props = {
  value: number | null;
  onChange: (value: number | null) => void;
};

export default function AdditionalStickersField({ value, onChange }: Props) {
  const handleAdditionalStickersChange: ChangeEventHandler<
    HTMLInputElement | HTMLTextAreaElement
  > = (event) => {
    const inputValue = event.target.value;
    const numericValue = inputValue === '' ? null : parseInt(inputValue, 10);
    onChange(numericValue);
  };

  return (
    <FormControl fullWidth>
      <TextField
        variant='outlined'
        label='Request Additional Sign Stickers'
        helperText='Enter number of additional stickers, leave blank if none'
        inputProps={{
          inputMode: 'numeric',
          pattern: '[0-9]*',
          maxLength: 1000,
        }}
        value={value ?? ''}
        id='additional-stickers'
        name='additional-stickers'
        onChange={handleAdditionalStickersChange}
      />
    </FormControl>
  );
}
